import { Subscription } from 'rxjs';

import { AlertService } from '@app/shared/alert.service';
import { SpinnerService } from '@app/shared/spinner.service';
import { PartnerService } from '@app/common/partner/partner.service';
import { GeoService, GeoAddress } from '@app/shared/geo.service';
import * as constants from '@app/shared/constants';

// Carte de l'adresse de livraison, partagée par la fenêtre des livraisons (F2) et celle de la location (cufs Latitude/Longitude, docs/geolocalisation-adresses.md).
export class DeliveryGeo {
	lat: number | null = null;
	lng: number | null = null;
	dirty = false;						// coordonnées calculées/déplacées, pas encore persistées sur l'adresse client
	status: '' | 'introuvable' = '';
	// Résultat BAN qui n'est PAS franc : affiché comme proposition, jamais persisté seul ; porte le libellé réellement retenu par la BAN.
	doubt: GeoAddress | null = null;
	private subscriptions = new Subscription();

	constructor(private geoService: GeoService, private partnerService: PartnerService, private spin: SpinnerService, private alertService: AlertService) {}

	// Coordonnées de l'adresse : depuis la base sinon géocodage BAN ; `current` relit l'adresse affichée au retour de la BAN (autre commande chargée entre-temps).
	init(address: any, customerName: string | undefined, current: () => any): void {
		this.lat = null;
		this.lng = null;
		this.dirty = false;
		this.status = '';
		this.doubt = null;
		if (!address) { this.status = 'introuvable'; return; }
		// pointOf écarte le couple (0, 0) des lignes créées sans géocodage : il repart au BAN.
		const p = GeoService.pointOf(address.data?.cufs?.[constants.CUF_ADDRESS_LAT], address.data?.cufs?.[constants.CUF_ADDRESS_LNG]);
		if (p) { this.lat = p.lat; this.lng = p.lon; return; }	// déjà en base : aucun appel réseau
		const q = GeoService.geoQueryOf({ ...address, name: customerName });
		if (GeoService.isEmptyQuery(q)) { this.status = 'introuvable'; return; }
		const addrId = address.id;
		this.subscriptions.add(this.geoService.geocode$(q).subscribe((geo) => {
			// Réponse obsolète : rien n'est écrit, sinon les coordonnées de l'ancienne adresse seraient persistées sur la nouvelle.
			if (current()?.id !== addrId) return;
			if (!geo) { this.status = 'introuvable'; return; }
			this.lat = geo.lat;
			this.lng = geo.lon;
			// Seul un verdict franc est à persister : un axe de rue écrit sans relecture a figé « Allée de la Clairière » sur l'EHPAD Eden Roc, à 919 m.
			this.dirty = geo.trust === 'exact';
			this.doubt = geo.trust === 'exact' ? null : geo;
		}));
	}

	moved(c: { lat: number; lon: number }): void {	// pin déplacé à la main sur la carte
		this.lat = c.lat;
		this.lng = c.lon;
		this.dirty = true;
	}

	// Persiste les coordonnées sur l'adresse client (event PARTNER, ligne d'adresse seule) puis continue ; un échec alerte sans bloquer le flux appelant.
	saveIfDirty(customerId: number, address: any, done: () => void): void {
		if (!this.dirty || this.lat === null || this.lng === null || !address) { done(); return; }
		this.subscriptions.add(this.partnerService.saveAddressCoords$(customerId, address.id, this.lat, this.lng).pipe(this.spin.block('Enregistrement des coordonnées…')).subscribe({
			next: () => { this.dirty = false; done(); },
			error: (e) => {
				console.error('saveAddressCoords$', e);
				this.alertService.error("Coordonnées GPS non enregistrées sur l'adresse client");
				done();
			},
		}));
	}

	destroy(): void {
		this.subscriptions.unsubscribe();
	}
}
